import AbsComponent from "../../components/AbsComponent";
import Pagination from "../../components/Pagination";

export default class AbsList extends AbsComponent{
    pageSize = 30;

    constructor(_name='', _store={}, _actions={}, _router={}, _el=''){
        super(_name, _store, _actions, _router, _el);

        this.pagination = new Pagination('page', this.store, this.actions, this.router, '.ui-pagination', this.pageSize);
        this.loading = jQuery('.gameinfo-result__list .nc-community-loader');

        this.paramsStack = [];
        this.listApiPath = ``;
        this.ListItemCon = null;
    }

    stack(_newVal, _oldVal, _path){
        this.paramsStack.push( _path );
    }
    
    loadList(_newVal, _oldVal, _path){
        if (!_newVal || this.paramsStack.length<1) return;

        this.loading.addClass('is-show');
        axios( {
            method: 'GET',
            url: this.store.getState().config.apiDomain + this.listApiPath,
            withCredentials: (window.isLoginFlag === 'true'), params: this.getParams()
        })
        .then( (_res) => {
            this.render(_res.data);
            this.pagination.render(_res.data.pagination);
        })
        .catch( (error) => {
            console.error( '[AbsList] loadList error :', error.response );
            if (error.response?.data?.result?.error === "Unauthorized") {
                this.router.goMultiParam({favorite: false});
                window.GNBLogin();
            }else{
                this.render({error:true});
                this.pagination.render({"page":1, "total":0});
            }
        })
        .then( (d) => {
            this.loading.removeClass('is-show');
        } );
        this.paramsStack = [];
    }

    getParams(){}

    makeParams(_obj, _key, _val){
        if(_val){
            _obj[_key] = _val;
        }
    }

    render(_data = {}){
        $('.gameinfo-result__list .ui-table').toggle(_data.contents?.length>0);
        
        const l10n = this.store.getState().config.l10n;

        if (_data.contents?.length<1) {
            $('.gameinfo-result__list .nodata').show().html(l10n['common.noSearchResults'].replace(/\n/gi, '<br>'));
            if(this.name==='List-crafts'){
                $('.gameinfo-result__list .nodata').append(`<div class="nodata-tip-craft">${l10n['common.failedSearchTip']}</div>`)
            }
        }
        if (_data.contents?.length<1 && this.store.getState().favorite==='true') {
            $('.gameinfo-result__list .nodata').show().html(l10n['common.noFavorites'].replace('{s}', '<i class="ico-favorite"></i>').replace(/\n/gi, '<br>'));
        }
        if (_data.error) {
            $('.gameinfo-result__list .nodata').show().html(l10n['common.failedSearch'].replace(/\n/gi, '<br>'));
        }
        
        if(_data.contents?.length>0){
            $('.gameinfo-result__list .nodata').hide();
            let template = _data.contents.map( it =>{ 
                const item = new this.ListItemCon('', this.store, this.actions, this.router, '', it);
                return item.itemEl;
            } );

            $(this.el).empty().append(template);
        }

        $('.gameinfo-result__util .count').html(_data.pagination?.total || '0');
    }

} // end of class